<div class="main">
    <div class="section">
        <div class="header">
            <div class="left">
                <div class="title">
                    {{'REGISTERED_VEHICLES.registeredVehicles' | translate}}
                </div>
            </div>
            <div class="right">
                <div class="button" (click)="openupdateFreightDialog()">
                    <div class="label">
                        {{'REGISTERED_VEHICLES.registerVehicle' | translate}}
                    </div>
                </div>
            </div>
        </div>

        <table mat-table *ngIf="vehicles.length" [dataSource]="vehicles">
            <ng-container matColumnDef="no">
                <th mat-header-cell *matHeaderCellDef> {{'REGISTERED_VEHICLES.slno' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.no}} </td>
            </ng-container>
            <ng-container matColumnDef="vehiclePlate">
                <th mat-header-cell *matHeaderCellDef> {{'REGISTERED_VEHICLES.vehiclePlate' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.vehiclePlate}} </td>
            </ng-container>
            <ng-container matColumnDef="seqNo">
                <th mat-header-cell *matHeaderCellDef> {{'REGISTERED_VEHICLES.seqNo' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.seqNo}} </td>
            </ng-container>
            <ng-container matColumnDef="plateType">
                <th mat-header-cell *matHeaderCellDef> {{'REGISTERED_VEHICLES.plateType' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.plateType}} </td>
            </ng-container>
            <ng-container matColumnDef="imei">
                <th mat-header-cell *matHeaderCellDef> {{'REGISTERED_VEHICLES.imei' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.imei}} </td>
            </ng-container>
            <ng-container matColumnDef="activity">
                <th mat-header-cell *matHeaderCellDef> {{'REGISTERED_VEHICLES.activity' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.activity}} </td>
            </ng-container>
            <ng-container matColumnDef="refKey">
                <th mat-header-cell *matHeaderCellDef> {{'REGISTERED_VEHICLES.refKey' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.refKey}} </td>
            </ng-container>
            <ng-container matColumnDef="carrier">
                <th mat-header-cell *matHeaderCellDef> {{'REGISTERED_VEHICLES.carrier' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.carrier}} </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> {{'REGISTERED_VEHICLES.actions' | translate}} </th>
                <td mat-cell *matCellDef="let element">
                    <div class="buttons">
                        <div class="button">
                            <mat-select placeholder="Actions" style="width: 80px;padding: 5px;
        background: #631d4f;
        color: #fff;
        border-radius: 4px;">
                                <mat-option value="Enquiry">
                                    <mat-icon aria-hidden="false" class="material-icons-outlined"
                                        aria-label="Example home icon">delete_outline</mat-icon>
                                    {{'REGISTERED_VEHICLES.enquiry' | translate}}
                                </mat-option>
                                <mat-option value="Delete">
                                    <mat-icon class="material-icons-outlined" aria-hidden="false"
                                        aria-label="Example home icon">delete_outline</mat-icon>
                                    {{'REGISTERED_VEHICLES.delete' | translate}}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </div>
</div>
<ng-template #registerVehicleDialog>
    <div class="dialogMain">
        <div *ngIf="showLoader" class="loader">
            <div class="load">
                <mat-spinner></mat-spinner>
            </div>
        </div>
        <div class="section">
            <div class="header">
                <div class="label">
                    <span>
                        {{ "REGISTERED_VEHICLES.registerVehicle" | translate }}
                    </span>
                </div>
                <i class="material-icons" (click)="closeDialog();">clear</i>
            </div>
            <div class="bodySection">
                <div class="top">
                    <div class="left">

                        <div class="container">
                            <div class="label">
                                <span>
                                    {{ "REGISTERED_VEHICLES.seqNo" | translate }}
                                </span>
                            </div>
                            <div class="input">
                                <input class="textInput" type="text"
                                    placeholder="{{ 'REGISTERED_VEHICLES.seqNo' | translate }}" [(ngModel)]="seqNo" />
                            </div>
                        </div>
                        <div class="container">
                            <div class="label">
                                <span>
                                    {{ "REGISTERED_VEHICLES.vehiclePlate" | translate }}
                                </span>
                            </div>
                            <div class="input">
                                <mat-select style="border: solid 1px #e3e3e3; width: 88%;
    padding-left: 5px
px
;
    font-size: 14px;
    padding: 6px;
    border-radius: 4px;" [placeholder]="'REGISTERED_VEHICLES.vehiclePlate' | translate ">
                                    <mat-option class="textInput" *ngFor="let vehicle of vehicleArr"
                                        (onSelectionChange)="selectVehicleType(vehicle, $event)" [value]="vehicle._id">
                                        {{vehicle.regNo}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="container">
                            <div class="label">
                                <span>
                                    {{ "REGISTERED_VEHICLES.imei" | translate }}
                                </span>
                            </div>
                            <div class="input">
                                <input class="textInput" type="text"
                                    placeholder="{{ 'REGISTERED_VEHICLES.imei' | translate }}" [(ngModel)]="imei" />
                            </div>
                        </div>

                    </div>
                    <div class="right">

                        <div class="container">
                            <div class="label">
                                <span>
                                    {{ "REGISTERED_VEHICLES.activity" | translate }}
                                </span>
                            </div>
                            <div class="input">
                                <input class="textInput" type="text"
                                    placeholder="{{ 'REGISTERED_VEHICLES.activity' | translate }}"
                                    [(ngModel)]="activity" />
                            </div>
                        </div>
                        <div class="container">
                            <div class="label">
                                <span>
                                    {{ "REGISTERED_VEHICLES.plateType" | translate }}
                                </span>
                            </div>
                            <div class="input">
                                <input class="textInput" type="text"
                                    placeholder="{{ 'REGISTERED_VEHICLES.plateType' | translate }}"
                                    [(ngModel)]="plateType" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="button" style="border: solid 1px #631d4f;
    color: #631d4f;">
                        <div class="label">
                            {{ "REGISTERED_VEHICLES.register" | translate }}
                        </div>
                    </div>
                    <div class="button" style="border: solid 1px #a2a2a2;
    color: #aeaeae;">
                        <div class="label">
                            {{ "REGISTERED_VEHICLES.cancel" | translate }}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</ng-template>